<template>
  <v-card dark class="mt-2">
    <v-toolbar card prominent class="transparent">
      <v-toolbar-title>
        <div class="title mt-3" v-if="value.type == 'ProfileRequirementGroup'">
          Candidate Requirement
        </div>
        <div class="title mt-3" v-if="value.type == 'ProfileQualificationRequirementGroup'">
          Qualification Requirement
        </div>
        <div class="title mt-3" v-if="value.type == 'ExperienceRequirementGroup'">
          Experience Requirement
        </div>
        <p class="subheading">{{ subtitle }}</p>
      </v-toolbar-title>

      <v-spacer />

      <can I="edit" a="Opportunity">
        <v-menu v-if="!editing" left>
          <v-tooltip top slot="activator">
            <v-btn small flat fab slot="activator" ref="menuActivator">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <span>Add requirement</span>
          </v-tooltip>

          <v-list ref="optionsList">
            <v-list-tile
              v-if="value.type == 'ProfileRequirementGroup'"
              @click="addRequirement('Requirement::Age')"
            >
              <v-list-tile-title>Age requirement</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              v-if="value.type == 'ProfileRequirementGroup'"
              @click="addRequirement('Requirement::Gender')"
            >
              <v-list-tile-title>Gender requirement</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              v-if="value.type == 'ProfileRequirementGroup'"
              @click="addRequirement('Requirement::Location')"
              ref="addLocationButton"
            >
              <v-list-tile-title>Location requirement</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              v-if="value.type == 'ProfileRequirementGroup'"
              @click="addRequirement('Requirement::Nationality')"
              ref="addNationalityButton"
            >
              <v-list-tile-title>Nationality requirement</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              v-if="value.type == 'ProfileRequirementGroup'"
              @click="addRequirement('Requirement::WorkExperience')"
            >
              <v-list-tile-title>Work Experience</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              v-if="value.type == 'ProfileRequirementGroup'"
              @click="addRequirement('Requirement::WorkRight')"
            >
              <v-list-tile-title>Work Rights</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              v-if="value.type == 'ProfileRequirementGroup'"
              @click="addRequirement('Requirement::StudyRight')"
            >
              <v-list-tile-title>Study Rights</v-list-tile-title>
            </v-list-tile>

            <v-list-tile
              v-if="value.type == 'ProfileQualificationRequirementGroup'"
              @click.native="addRequirement('Requirement::QualificationCategory')"
            >
              <v-list-tile-title>Category requirement</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              v-if="value.type == 'ProfileQualificationRequirementGroup'"
              @click.native="addRequirement('Requirement::QualificationCommencement')"
            >
              <v-list-tile-title>Commencement requirement</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              v-if="value.type == 'ProfileQualificationRequirementGroup'"
              @click.native="addRequirement('Requirement::QualificationCompletion')"
            >
              <v-list-tile-title>Completion requirement</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              v-if="value.type == 'ProfileQualificationRequirementGroup'"
              @click.native="addRequirement('Requirement::QualificationDiscipline')"
            >
              <v-list-tile-title>Discipline requirement</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              v-if="value.type == 'ProfileQualificationRequirementGroup'"
              @click.native="addRequirement('Requirement::QualificationGrade')"
            >
              <v-list-tile-title>Grade requirement</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              v-if="value.type == 'ProfileQualificationRequirementGroup'"
              @click.native="addRequirement('Requirement::QualificationInstitution')"
            >
              <v-list-tile-title>Institution requirement</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              v-if="value.type == 'ProfileQualificationRequirementGroup'"
              @click.native="addRequirement('Requirement::QualificationLevel')"
            >
              <v-list-tile-title>Level requirement</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              v-if="value.type == 'ProfileQualificationRequirementGroup'"
              @click.native="addRequirement('Requirement::QualificationType')"
            >
              <v-list-tile-title>Type requirement</v-list-tile-title>
            </v-list-tile>

            <v-list-tile
              v-if="value.type == 'ExperienceRequirementGroup'"
              @click="addRequirement('Requirement::ExperienceDiscipline')"
            >
              <v-list-tile-title>Discipline requirement</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              v-if="value.type == 'ExperienceRequirementGroup'"
              @click="addRequirement('Requirement::ExperienceDuration')"
            >
              <v-list-tile-title>Duration requirement</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              v-if="value.type == 'ExperienceRequirementGroup'"
              @click="addRequirement('Requirement::ExperienceIndustry')"
            >
              <v-list-tile-title>Industry requirement</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              v-if="value.type == 'ExperienceRequirementGroup'"
              @click="addRequirement('Requirement::ExperienceType')"
            >
              <v-list-tile-title>Type requirement</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </can>

      <can I="edit" a="Opportunity">
        <v-tooltip top v-if="!editing">
          <v-btn small fab slot="activator" @click="editing = true">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <span>Edit</span>
        </v-tooltip>
      </can>
    </v-toolbar>

    <can I="edit" a="Opportunity" v-if="editing">
      <v-card-text>
        <v-text-field
          label="Description"
          v-model="value.name"
          placeholder="Simplify this requirement group in a single short, simple sentence"
          clearable
        />
        <v-checkbox label="This group of requirements must be met" v-model="value.mandatory" />
        <v-checkbox label="This group of requirements are reversed" v-model="value.negative" />
      </v-card-text>
      <v-card-actions>
        <v-dialog v-model="removing" max-width="600px">
          <v-btn flat :error="value.requirements.length > 0" slot="activator">
            <v-icon left>mdi-delete</v-icon> Remove
          </v-btn>

          <v-card dark>
            <v-card-title class="title">Are you sure?</v-card-title>
            <v-card-text>This will remove all requirements in this group as well.</v-card-text>
            <v-card-actions><v-spacer />
              <v-btn flat @click="removing = false">Cancel</v-btn>
              <v-btn @click="remove">Delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-spacer />

        <v-btn flat @click="editing = false">
          Cancel
        </v-btn>

        <v-btn @click="update"> <v-icon left>mdi-content-save</v-icon> Update </v-btn>
      </v-card-actions>
    </can>

    <v-divider v-if="editing" />

    <v-card-text v-if="value.name && !editing" class="text-xs-center">
      &laquo; {{ value.name }} &raquo;
    </v-card-text>

    <table class="v-table theme--dark">
      <tbody>
        <tr
          v-for="( requirement, i ) in mandatory" :key="`requirement-row-${i}`"
          :is="componentFor(requirement)"
          :requirement="requirement"
          :first="requirement == mandatory[0]"
        ></tr>
        <tr v-if="mandatory.length > 0 && optional.length > 0" class="spacer">
          <td colspan="3" class="text-xs-center"><small>AND</small></td>
        </tr>
        <tr
          v-for="( requirement, i ) in optional" :key="`requirement-row-${i}`"
          :is="componentFor(requirement)"
          :requirement="requirement"
          :first="requirement == optional[0]"
        ></tr>
      </tbody>
    </table>
  </v-card>
</template>

<script>
// Components
import Age from '@/components/opportunities/requirements/Age'
import ExperienceDiscipline from '@/components/opportunities/requirements/ExperienceDiscipline'
import ExperienceDuration from '@/components/opportunities/requirements/ExperienceDuration'
import ExperienceIndustry from '@/components/opportunities/requirements/ExperienceIndustry'
import ExperienceType from '@/components/opportunities/requirements/ExperienceType'
import Gender from '@/components/opportunities/requirements/Gender'
import Location from '@/components/opportunities/requirements/Location'
import Nationality from '@/components/opportunities/requirements/Nationality'
import QualificationCategory from '@/components/opportunities/requirements/QualificationCategory'
import QualificationCommencement from '@/components/opportunities/requirements/QualificationCommencement'
import QualificationCompletion from '@/components/opportunities/requirements/QualificationCompletion'
import QualificationDiscipline from '@/components/opportunities/requirements/QualificationDiscipline'
import QualificationGrade from '@/components/opportunities/requirements/QualificationGrade'
import QualificationInstitution from '@/components/opportunities/requirements/QualificationInstitution'
import QualificationLevel from '@/components/opportunities/requirements/QualificationLevel'
import QualificationType from '@/components/opportunities/requirements/QualificationType'
import StudyRight from '@/components/opportunities/requirements/StudyRight'
import WorkExperience from '@/components/opportunities/requirements/WorkExperience'
import WorkRight from '@/components/opportunities/requirements/WorkRight'

// Vue Component
export default {
  components: {
    Age,
    ExperienceDiscipline,
    ExperienceDuration,
    ExperienceIndustry,
    ExperienceType,
    Gender,
    Location,
    Nationality,
    QualificationCategory,
    QualificationCommencement,
    QualificationCompletion,
    QualificationDiscipline,
    QualificationGrade,
    QualificationInstitution,
    QualificationLevel,
    QualificationType,
    StudyRight,
    WorkExperience,
    WorkRight,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return { editing: false, removing: false }
  },
  computed: {
    mandatory() {
      return this.value.requirements.filter(req => {
        return req.mandatory
      })
    },
    optional() {
      return this.value.requirements.filter(req => {
        return !req.mandatory
      })
    },
    subtitle() {
      if (this.value.type == 'ProfileRequirementGroup') {
        if (this.value.mandatory) {
          if (this.value.negative) {
            return "The candidate's profile must not satisfy these conditions"
          } else {
            return "The candidate's profile must satisfy these conditions"
          }
        } else {
          if (this.value.negative) {
            return "The candidate's profile may not satisfy these conditions"
          } else {
            return "The candidate's profile may satisfy these (or another) set of conditions"
          }
        }
      }
      if (this.value.type == 'ProfileQualificationRequirementGroup') {
        if (this.value.mandatory) {
          if (this.value.negative) {
            return 'The candidate must not have a qualification that satisfies these conditions'
          } else {
            return 'The candidate must have a qualification that satisfies these conditions'
          }
        } else {
          // mandatory == false
          if (this.value.negative) {
            return "Having a qualification that doesn't satisfy these conditions may qualify the candidate, but satisfying them won't necessarily disqualify them"
          } else {
            return "Having a qualification that satisfies these conditions may qualify the candidate, but not satisfying them won't necessarily disqualify them"
          }
        }
      }
      if (this.value.type == 'ExperienceRequirementGroup') {
        if (this.value.mandatory) {
          if (this.value.negative) {
            return 'The candidate must not have experience that satisfies these conditions'
          } else {
            return 'The candidate must have experience that satisfies these conditions'
          }
        } else {
          // mandatory == false
          if (this.value.negative) {
            return "Having experience that doesn't satisfy these conditions may qualify the candidate, but satisfying them won't necessarily disqualify them"
          } else {
            return "Having experience that satisfies these conditions may qualify the candidate, but not satisfying them won't necessarily disqualify them"
          }
        }
      }
      return ""
    },
  },
  methods: {
    update() {
      this.$store
        .dispatch('admin/opportunities/updateRequirementGroup', this.value)
        .then(() => (this.editing = false))
    },
    remove() {
      this.$store
        .dispatch('admin/opportunities/removeRequirementGroup', this.value)
        .then(
          () => this.$store.dispatch('snackbarSuccess', 'Requirement Group Removed'),
          () => this.$store.dispatch('snackbarError', 'Could not remove Requirement Group')
        )
    },
    componentFor(requirement) {
      return requirement.type.split('::')[1]
    },
    addRequirement(type) {
      this.value.requirements.push({
        type,
        requirementGroupId: this.value.id,
        id: null,
        editing: true,
        mandatory: true,
        negative: false,
        value: '',
      })
    },
  },
}
</script>
